import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { IonLabel } from '@ionic/angular/standalone';

import { ContactAvatarComponent } from '../contact-avatar/contact-avatar.component';

@Component({
  selector: 'lib-contact-profile',
  standalone: true,
  imports: [CommonModule, IonLabel, ContactAvatarComponent],
  templateUrl: './contact-profile.component.html',
  styleUrls: ['./contact-profile.component.scss'],
})
export class ContactProfileComponent {
  // inputs
  alias = input<string>('');
  role = input<string | undefined>(undefined);
  count = input<string | undefined>(undefined);
}
